import { Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from "@angular/core"
import { ModalRef } from "../../../shared-components/modal/modal-ref"
import { GenericInteractiveMedia } from "../../../models/resource/media"
import { NavigationStart, Router } from "@angular/router"
import { filter, map, takeUntil, tap } from "rxjs/operators"
import { Observable, Subject } from "rxjs"

@Component({
    selector: "app-interactive-preview-modal",
    templateUrl: "./interactive-preview-modal.component.html",
    styleUrls: ["./interactive-preview-modal.component.scss"],
    standalone: false,
})
export class InteractivePreviewModalComponent implements OnInit, OnDestroy {
    @Input() public interactiveMedia: GenericInteractiveMedia
    @ViewChild("interactive") iframeRef: ElementRef<HTMLIFrameElement>
    interactionStart: Date = new Date()
    interactionTimeInSeconds: number = 0

    private destroyed$: Subject<void> = new Subject<void>()
    //corner case for the user when navigates back or forward from browser left/right arrows
    private routerObservable: Observable<NavigationStart> = this.router.events.pipe(
        takeUntil(this.destroyed$),
        filter((event) => event instanceof NavigationStart),
        map((event: NavigationStart) => event),
        tap(() => this.close())
    )

    constructor(
        private activeModal: ModalRef,
        private router: Router
    ) {}

    ngOnInit() {
        this.routerObservable.subscribe()
        this.changeDocumentBodyBehaviour()
    }

    private updateInteraction(): void {
        this.interactionTimeInSeconds =
            (new Date().getTime() - this.interactionStart.getTime()) / 1000
        // @ts-ignore
        let dataLayer = window.dataLayer || []
        dataLayer.push({ interactiveInteractionTime: this.interactionTimeInSeconds })
    }

    private changeDocumentBodyBehaviour(open: boolean = true): void {
        document.getElementsByTagName("html")[0].style.overflow = open ? "hidden" : "visible"
        document.getElementsByClassName("white-header")[0]["style"].position = open
            ? "fixed"
            : "relative"
        document.getElementsByClassName("white-header")[0]["style"].pointerEvents = open
            ? "none"
            : "all"
        document.getElementsByClassName("white-header")[0]["style"].zIndex = open ? "10001" : "100"
        document.getElementsByClassName("white-header")[0].children[0]["style"].opacity = open
            ? "0.7"
            : "1"
    }

    public close() {
        this.updateInteraction()
        this.changeDocumentBodyBehaviour(false)
        window.location.reload()
    }

    ngOnDestroy() {
        this.changeDocumentBodyBehaviour(false)
        this.updateInteraction()
        this.destroyed$.next()
        this.destroyed$.complete()
        this.activeModal.close()
    }
}
